import http from "./http";

class Events {
  sendEvent(type, args = {}) {
    const data = Object.assign(
      {
        event: type,
      },
      args
    );
    return http.post("send_ac_event", data);
  }
}

export default new Events();
